import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Dropdown, Checkbox } from 'semantic-ui-react';
import i18next from 'i18next';

import SideEditor from '../../general/SideEditor';
import SendInvoice from './SendInvoice';

import { fetchPaymentsReport, setEditedEntity } from '../../../actions';
import { updateUrlState } from '../../../helpers/url';

import GeneralPaymentsReport from './General/PaymentsReport';
import RestaurantsPaymentsReport from './Restaurants/RestaurantsReport';

class ReportsContainer extends Component {
    state = {
        date: null,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        canceled: false,
        type: 'byPayments',
        ids: this.props.restId ? [this.props.restId] : [],
    };

    constructor(props) {
        super(props);

        this.renderReportByType = this.renderReportByType.bind(this);
    }

    componentDidMount() {
        const { location, fetchPaymentsReport } = this.props;
        const queryParams = new URLSearchParams(location.search);

        const reportState = {};

        if (queryParams.has('date')) reportState.date = parseInt(queryParams.get('date'));
        if (queryParams.has('month')) reportState.month = parseInt(queryParams.get('month'));
        if (queryParams.has('year')) reportState.year = parseInt(queryParams.get('year'));
        if (queryParams.has('canceled')) reportState.canceled = queryParams.get('canceled') === "true";
        if (queryParams.has('reportType')) reportState.type = queryParams.get('reportType');
        if (queryParams.has('restaurantsIds')) reportState.ids = queryParams.get('restaurantsIds').split(',');

        this.setState(reportState, () => fetchPaymentsReport(this.state));
    }

    renderReportByType() {
        switch (this.state.type) {
            case 'byRestaurants':
            case 'byChains':
                return <RestaurantsPaymentsReport month={this.state.month} year={this.state.year} />;
            case 'byPayments':
            default:
                return <GeneralPaymentsReport canceled={this.state.canceled} />;
        }
    }

    updateFilters(filters) {
        const { history, location, fetchPaymentsReport } = this.props;

        const newState = {};

        if ('reportType' in filters) newState.type = filters.reportType;
        if ('restaurantsIds' in filters) newState.ids = filters.restaurantsIds || [];
        if ('canceled' in filters) newState.canceled = filters.canceled;
        if ('date' in filters) newState.date = filters.date;
        if ('month' in filters) newState.month = filters.month;
        if ('year' in filters) newState.year = filters.year;

        filters.pageNumber = 1;

        updateUrlState(history, location, filters);
        this.setState(newState, () => fetchPaymentsReport(this.state));
    }

    render() {
        const {
            permissions, onSend, setEditedEntity, reportTypes, restaurants, restaurant, chains,
            years, months
        } = this.props;
        const days = getDaysOfMonth(this.state.year, this.state.month - 1);

        return (
            <div style={{ padding: 10 }}>

                <Form>
                    <Form.Group>
                        <Form.Field>
                            <Dropdown compact selection
                                options={reportTypes.map((value) => ({ value, text: i18next.t(value) }))}
                                value={this.state.type}
                                onChange={(e, { value }) => {
                                    this.updateFilters({ reportType: value, restaurantsIds: restaurant ? [restaurant.id] : undefined, canceled: false });
                                }}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Dropdown multiple search selection
                                placeholder={i18next.t(this.state.type === 'byChains' ? 'selectChain' : 'selectRestaurant')}
                                options={(this.state.type === 'byChains' ? chains : restaurants).map((rest) => ({ value: rest.id, text: rest.name }))}
                                value={this.state.ids}
                                onChange={(e, { value }) => {
                                    this.updateFilters({ restaurantsIds: value });
                                }}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Dropdown compact selection
                                options={years.map((year) => ({ value: year, text: year }))}
                                value={this.state.year}
                                onChange={(e, { value }) => {
                                    this.updateFilters({ year: value });
                                }}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Dropdown compact selection
                                placeholder={i18next.t('selectMonth')}
                                options={[{ value: null, text: '' }].concat(months.map((month) => ({ value: month, text: month })))}
                                value={this.state.month}
                                onChange={(e, { value }) => {
                                    this.updateFilters({ month: value });
                                }}
                            />
                        </Form.Field>
                        <Form.Field>
                            <Dropdown compact selection
                                placeholder={i18next.t('selectDay')}
                                options={[{ value: null, text: '' }, { key: -1, value: new Date().getDate(), text: i18next.t('today') }].concat(days.map((date) => ({ value: date, text: date })))}
                                value={this.state.date}
                                onChange={(e, { value }) => {
                                    this.updateFilters({ date: value ? value : undefined });
                                }}
                            />
                        </Form.Field>
                        <Form.Field className='pi-payment-report-filters-canceled'>
                            <Checkbox toggle
                                label={i18next.t('orders.canceled')}
                                checked={this.state.canceled}
                                onChange={(event, data) => {
                                    this.updateFilters({ canceled: data.checked });
                                }} />
                        </Form.Field>
                    </Form.Group>
                </Form>

                <SideEditor
                    title={i18next.t('sendInvoice')}
                    visible={permissions.admin && onSend}
                    handleClose={() => setEditedEntity(null)}
                >
                    <SendInvoice />
                </SideEditor>
                {this.renderReportByType()}

            </div>
        );
    }
}

ReportsContainer.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object,
    restaurant: PropTypes.object,
    fetchPaymentsReport: PropTypes.func,
    paymentsReport: PropTypes.array,
    restaurants: PropTypes.array,
    reportTypes: PropTypes.array,
    months: PropTypes.array,
    years: PropTypes.array,
    chains: PropTypes.array,
    permissions: PropTypes.object,
    onSend: PropTypes.bool,
    setEditedEntity: PropTypes.func,
    
};

const mapStateToProps = (state, ownProps) => {
    const { restaurants, chains } = state.businessApp;
    const { permissions } = state.auth;
    const { paymentsReport } = state.businessApp.reports;
    const time = new Date();
    const year = time.getFullYear();
    const years = [year - 2, year - 1, year];
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const reportTypes = !ownProps.restaurant ? ['byChains', 'byRestaurants', 'byPayments'] : ['byRestaurants', 'byPayments'];
    const { restId } = ownProps.match.params;
    const onSend = state.editor.type === 'invoice';

    return { permissions, years, months, restId, restaurants, chains, onSend, paymentsReport, reportTypes };
};

const getDaysOfMonth = (year, month) => {
    const days = [];
    for (let index = 1; index <= new Date(year, month, 0).getDate(); index++) {
        days.push(index);
    }
    return days;
};

export default connect(mapStateToProps, { fetchPaymentsReport, setEditedEntity })(ReportsContainer);
